import { ICompactProduct } from "api/interfaces/get-page-details/common/CompactProduct.type";

export function getProductCategory(product: ICompactProduct) {
  return product?.primaryCategory || product?.category || product?.enCategory;
}
